import { supabase } from '../supabaseClient';

/* Report des heures de maintenance d'une année de contrat sur la suivante. */

export function setMaintenanceCarryOvers(phaseId, reports) {
  return supabase.from('phases').update({ maintenance_reports: reports }).eq('id', phaseId);
}
